export type ImageType =
  | "mechanism_diagram"
  | "framework_diagram"
  | "taxonomy_diagram"
  | "timeline_evolution"
  | "flow_diagram"
  | "comparison_matrix"
  | "technical_roadmap"
  | "journal_cover";
export type ImageModel = "nano-banana-pro" | "gpt-image-2";

export const IMAGE_TYPE_LABELS: Record<ImageType, string> = {
  mechanism_diagram: "机制示意图",
  framework_diagram: "论文框架图",
  taxonomy_diagram: "分类体系图",
  timeline_evolution: "时间演进图",
  flow_diagram: "流程图",
  comparison_matrix: "对比矩阵图",
  technical_roadmap: "技术路线图",
  journal_cover: "期刊封面",
};

export const IMAGE_TYPE_VALUES = Object.keys(IMAGE_TYPE_LABELS) as ImageType[];

export const GENERATED_PROMPT_PREFIX_REGEX = /^请生成一张(?:机制示意图|论文框架图|分类体系图|时间演进图|流程图|对比矩阵图|技术路线图|期刊封面)。研究内容：/;

export function normalizeImageType(value?: string | null): ImageType {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (normalized === "framework_diagram" || normalized === "paper_framework") {
    return "framework_diagram";
  }
  if (normalized === "taxonomy_diagram") {
    return "taxonomy_diagram";
  }
  if (normalized === "timeline_evolution") {
    return "timeline_evolution";
  }
  if (normalized === "flow_diagram") {
    return "flow_diagram";
  }
  if (normalized === "comparison_matrix") {
    return "comparison_matrix";
  }
  if (normalized === "technical_roadmap") {
    return "technical_roadmap";
  }
  if (normalized === "journal_cover") {
    return "journal_cover";
  }
  return "mechanism_diagram";
}

export function getImageTypeLabel(imageType?: string | null) {
  return IMAGE_TYPE_LABELS[normalizeImageType(imageType)];
}

/** 与 UI 模型选择第一项保持一致 */
export const DEFAULT_IMAGE_MODEL: ImageModel = "gpt-image-2";

export function normalizeImageModel(value?: string | null): ImageModel {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (!normalized) {
    return DEFAULT_IMAGE_MODEL;
  }
  if (
    normalized === "gpt-image-2"
    || normalized === "gpt_image_2"
    || normalized === "gptimage2"
    || normalized === "azure"
  ) {
    return "gpt-image-2";
  }
  return "nano-banana-pro";
}
export type PreviousImagesMode = "none" | "upload";
export type ImageSize = "1K" | "2K" | "4K";
export type AspectRatio = "1:1" | "16:9" | "4:3" | "3:4";

export type ResearchDrawingFormValue = {
  userInput: string;
  modifyInstruction: string;
  researchDirection: string;
  imageModel: ImageModel;
  imageType: ImageType;
  previousImagesMode: PreviousImagesMode;
  previousImages: string[];
  imageSize: ImageSize;
  aspectRatio: AspectRatio;
  taskId?: number;
};

export type ImageGenerationRequest = {
  userInput: string;
  imageModel: ImageModel;
  researchDirection?: string;
  imageType: ImageType;
  imageSize: ImageSize;
  aspectRatio: AspectRatio;
  previousImages: string[];
  taskId?: number;
};

export type ImageGenerationTask = {
  taskId: number;
  status: -1 | 0 | 1 | 2;
  userInput: string;
  imageModel?: ImageModel;
  imageType: ImageType;
  previousImages: string[];
  researchDirection: string;
  imageSize: string;
  aspectRatio: string;
  beansCost: number;
  imageUrl: string;
  createTime: string;
  finishTime?: string | null;
};

export type ImageUploadResult = {
  url: string;
  filename: string;
};

export type ImageGenerationWsMessage =
  | {
    type: "task_created";
    data: {
      taskId: number;
      status: "created";
      beansCost: number;
      message: string;
    };
  }
  | {
    type: "task_status";
    data: {
      taskId: number;
      status: "generating" | "saving";
      message: string;
    };
  }
  | {
    type: "task_result";
    data: {
      taskId: number;
      imageUrl: string;
	      imageSize: ImageSize | string;
	      aspectRatio: AspectRatio | string;
	      beansCost: number;
	      imageType?: ImageType | string;
	      researchDirection?: string;
	    };
	  }
  | {
    type: "error";
    data: {
      taskId?: number;
      code?: number;
      errorType?: string;
      message: string;
    };
  }
  | {
    type: "done";
    data?: undefined;
  };
